export function pageFromLink(url: string | null | undefined): number | null {
  if (!url) return null;
  try {
    const page = Number(new URL(url, 'https://api.local').searchParams.get('page'));
    return Number.isInteger(page) && page >= 1 ? page : null;
  } catch {
    return null;
  }
}

export function totalPages(count: number, perPage: number): number {
  if (count <= 0 || perPage <= 0) return 1;
  return Math.ceil(count / perPage);
}

export function apiErrorMessage(error: unknown): string {
  if (!error || typeof error !== 'object') return '';
  const data = (error as { response?: { data?: unknown } }).response?.data;
  if (!data || typeof data !== 'object') return '';
  const body = data as { error?: unknown; results?: { error?: unknown } };
  if (typeof body.error === 'string' && body.error.trim()) return body.error.trim();
  if (typeof body.results?.error === 'string' && body.results.error.trim()) return body.results.error.trim();
  return '';
}
